import {
  createStyles,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';
import MaterialTable from 'material-table';
import QRCode from 'qrcode.react';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router';
import { getStationDetails } from '../../store/actions/stationDetails';
import { StationDetailsState } from '../../store/reducers/stationDetails';
import Loading from '../../components/Loading';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      display: 'flex',
      padding: theme.spacing(2),
    },
    stationInfo: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    userTablerContainer: {
      marginTop: theme.spacing(2),
      maxWidth: '100%',
    },
  })
);
interface RootState {
  stationDetails: StationDetailsState;
}

const StationDetails: React.FC = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  const match = useRouteMatch<{ id: string }>('/stations/:id');
  const stationId = match?.params.id;

  const dispatch = useDispatch();

  const stationDetails = useSelector(
    (state: RootState) => state.stationDetails
  );

  useEffect(() => {
    const fetchStationDetails = async (id: string) => {
      try {
        setLoading(true);
        await dispatch(getStationDetails(id));
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };

    if (stationId !== undefined) {
      fetchStationDetails(stationId);
    }
  }, [stationId, dispatch]);

  const rowClickHandler = (
    event: React.MouseEvent<Element, MouseEvent> | undefined,
    rowData: any
  ) => {};

  const getPageSize = (): number => {
    if (stationDetails.users.length < 5) {
      return 5;
    } else if (stationDetails.users.length < 10) {
      return 10;
    } else if (stationDetails.users.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <div>
      <Paper>
        <div className={classes.root}>
          <div className={classes.stationInfo}>
            <Typography variant="h6" gutterBottom component="h6">
              Station Details
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Company: {stationDetails.station?.companyName}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Station Name: {stationDetails.station?.name}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Station Address: {stationDetails.station?.address}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Station Postcode: {stationDetails.station?.postcode}
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Station Address: {stationDetails.station?.state}
            </Typography>
          </div>
          <div>
            <QRCode
              value={stationDetails.qr}
              size={300}
              bgColor={'#ffffff'}
              fgColor={'#000000'}
              level={'L'}
              includeMargin={false}
              renderAs={'svg'}
            />
          </div>
        </div>
      </Paper>

      <div className={classes.userTablerContainer}>
        <MaterialTable
          key={stationDetails.users.length}
          options={{
            search: false,
            pageSize: getPageSize(),
            pageSizeOptions: [],
          }}
          columns={[
            { title: 'Name', field: 'name' },
            { title: 'IC No.', field: 'icNumber' },
            { title: 'Contact Number', field: 'contactNumber' },
            { title: 'Temperature (°C)', field: 'temperature' },
            { title: 'Check In Time', field: 'timestamp' },
          ]}
          data={stationDetails.users.map((user) => {
            return {
              name: user.name,
              icNumber: user.icNumber,
              contactNumber: user.contactNumber,
              temperature: user.temperature,
              timestamp: user.timestamp?.toString(),
            };
          })}
          title="Users"
          onRowClick={(event, rowData) => rowClickHandler(event, rowData)}
        />
      </div>

      <Loading isLoading={loading} />
    </div>
  );
};

export default StationDetails;
